module.exports = __webpack_public_path__ + "static/what-is-code-9c97cb81a95ed80e54dcddafc69b2e74.png";